var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "xr-upgrade-dialog",
      attrs: {
        visible: _vm.visible,
        "close-on-click-modal": false,
        title: "",
        width: "700px",
        "append-to-body": "",
      },
      on: { close: _vm.closeView },
    },
    [
      _c("el-button", {
        staticClass: "close-button",
        attrs: { icon: "el-icon-close" },
        on: { click: _vm.closeView },
      }),
      _vm._v(" "),
      _c(
        "flexbox",
        {
          staticClass: "upgrade-header",
          attrs: { justify: "center", align: "center", orient: "vertical" },
        },
        [
          _c("span", { staticClass: "upgrade-header__title" }, [
            _vm._v("升级通知"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "upgrade-header__version" }, [
            _vm._v("版本" + _vm._s(_vm.WKConfig.version)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "content__title" }, [_vm._v("升级内容：")]),
        _vm._v(" "),
        _c("div", { staticClass: "content__content" }, [
          _vm._v(_vm._s(_vm.message)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeView } },
            [_vm._v("我知道了")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }